'use client';

import { useState } from 'react';
import Link from 'next/link';
import Image from 'next/image';
import Icon from '@/components/ui/AppIcon';

interface HeaderProps {
  className?: string;
}

const navigationItems = [
  { label: 'Solutions', href: 'https://wiliang.com/solutions' },
  { label: 'Outdoor', href: 'https://wiliang.com/outdoor-led-display/' },
  { label: 'Rental', href: 'https://wiliang.com/rentalled-screen' },
  { label: 'Contact Us', href: 'https://wiliang.com/contact-us' },
  { label: 'Blog', href: 'https://wiliang.com/wiliang-blog' },
];

const Header = ({ className = '' }: HeaderProps) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className={`fixed top-0 left-0 right-0 z-[1000] bg-card shadow-md ${className}`}>
      <div className="container mx-auto px-5 md:px-10">
        <div className="flex items-center justify-between h-[60px]">
          <Link href="/" className="flex items-center gap-3">
            <div className="relative w-32 h-10">
              <Image
                src="/assets/images/wiliang_logo-1766495883797.png"
                alt="Wiliang Logo"
                fill
                className="object-contain"
                priority
              />
            </div>
          </Link>

          <nav className="hidden lg:flex items-center gap-1">
            {navigationItems.map((item) => (
              <a
                key={item.label}
                href={item.href}
                target="_blank"
                rel="noopener noreferrer"
                className="px-4 py-2 rounded-lg font-body text-base text-text-primary hover:bg-surface transition-all duration-250 ease-out"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <a
              href="https://wiliang.com/contact-us"
              target="_blank"
              rel="noopener noreferrer"
              className="hidden lg:inline-flex items-center gap-2 px-6 py-2.5 bg-accent text-accent-foreground font-semibold rounded-lg hover:bg-accent/90 transition-colors duration-250 text-base"
            >
              Get Quote
            </a>
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="lg:hidden p-2 text-primary hover:bg-surface rounded-lg transition-colors duration-250"
              aria-label="Toggle menu"
            >
              <Icon name={isMenuOpen ? 'XMarkIcon' : 'Bars3Icon'} size={24} variant="outline" />
            </button>
          </div>
        </div>
      </div>

      {isMenuOpen && (
        <div className="lg:hidden bg-card border-t border-border">
          <nav className="container mx-auto px-5 py-4 flex flex-col gap-2">
            {navigationItems.map((item) => (
              <a
                key={item.label}
                href={item.href}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => setIsMenuOpen(false)}
                className="flex items-center gap-3 px-4 py-3 rounded-lg font-body text-base text-text-primary hover:bg-surface transition-all duration-250 ease-out"
              >
                {item.label}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;